import { LocaleValuesFragment } from 'src/generated/operations.ts';

export type AttributesListItem = [string, LocaleValuesFragment | null | undefined];
export type AttributesList = Array<AttributesListItem>;

export function createAttributesItem(
    label: string = '',
    value: LocaleValuesFragment | null | undefined = null,
): AttributesList {
    if (!value) {
        return [] as AttributesList;
    }
    return [[label, value]];
}
